import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';

import {colorsPalette, SMALL_MARGIN} from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: 'relative',
      display: 'flex',
      flexDirection:'column',
      color: colorsPalette.grayThird,
      paddingBottom: 24,
      marginBottom: 24,
      borderBottom: `2px solid ${colorsPalette.blueDark}`,

      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 13,
        paddingBottom: 0,
        borderBottom: 'none',
      },
    },
    itemLeftBlock: {
      color: colorsPalette.white,
      fontWeight: 'bold',
      flex: 1,
      marginBottom: SMALL_MARGIN,

      '& img': {
        width: 62,
        height: 43,
        objectFit: 'cover',
      },

      width: '60%',

      [theme.breakpoints.up('md')]: {
        width: '60%',
        marginBottom: 0,
      },
    },
    itemLeftBlockInner: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 18,
    },
    previewWrapper: {
      position: 'relative',
      marginRight: SMALL_MARGIN,
      height: 43,
    },
    tableTitle: {
      overflow: 'hidden',
      margin: 0,
      '&:not(:only-child)': {
        marginBottom: 2,
      },
    },
    itemHref: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
      color: colorsPalette.white,

      '&:hover': {
        color: colorsPalette.blue,
      },
    },
    cpdScore: {
      fontWeight: 'normal',
      margin: 0,
    },
    itemRightBlock: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginLeft: 80,
      [theme.breakpoints.up('md')]: {
        justifyContent: 'flex-end',
        marginLeft: 0,
      },
    },
    iconBtnWithText: {
      marginRight: SMALL_MARGIN/2,
      [theme.breakpoints.up('md')]: {
        marginRight: 1.5 * SMALL_MARGIN,
      },
    },
    addBtn: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    iconBtn: {
      border: 'none',
      background: 'transparent',
      padding: 9,
      '&:hover': {
        cursor: 'pointer',
      },
      '&:last-child': {
        marginRight: 0,
      },
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
      [theme.breakpoints.up('md')]: {
        marginRight: SMALL_MARGIN,
        display: 'block',
      },
    },
    icon: {
      width: 14,
      height: 14,
      minWidth: 14,
      color: colorsPalette.primary,
    },
  }),
);

export default useStyles;
